<template>
  <figure class="@container relative w-full overflow-hidden rounded-lg">
    <app-image
      :alt="teacher.full_name!"
      class="absolute inset-0 h-full w-full object-cover transition duration-500 group-hover:scale-105"
      :src="cover && teacher.cover_url ? teacher.cover_url : teacher.avatar_url"
    />

    <figcaption
      class="@[150px]:flex @[700px]:p-8 @[700px]:gap-1 absolute bottom-0 top-1/3 hidden w-full flex-col justify-end bg-gradient-to-t from-black/70 from-20% p-4 text-white transition duration-500"
    >
      <p
        class="@[170px]:text-sm @[200px]:text-base @[270px]:font-title @[270px]:text-xl @[700px]:text-2xl text-xs font-semibold"
      >
        {{ teacher.full_name }}
      </p>
      <div class="mt-2 flex gap-2">
        <teacher-companies-logos
          :companies="teacher.companies"
          :height="25"
          :max-width="`${100 / teacher.companies.length - 5}%`"
        />
      </div>

      <p
        class="@[170px]:block @[200px]:text-sm @[700px]:text-base mt-2 hidden text-xs"
      >
        {{ teacher.job }}
      </p>
    </figcaption>
  </figure>
</template>

<script lang="ts" setup>
defineProps<{
  teacher: Pick<
    DatabaseTable<"teachers">,
    "full_name" | "job" | "avatar_url" | "pinned" | "cover_url"
  > & {
    companies: DatabaseTable<"companies">[];
  };
  cover?: boolean;
}>();
</script>
